import gql from "graphql-tag";

const DutyProps = gql`
	fragment DutyProps on RotaDutyPeroid {
		id
		name
		created_at
	}
`;

const LIST = gql`
	query GetDuties {
		GetRotaDutyPeroids {
			docs {
				...DutyProps
			}
		}
	}
	${DutyProps}
`;

const CREATE = gql`
	mutation NewDuty($name: String!) {
		CreateRotaDutyPeroid(name: $name) {
			message
			doc {
				...DutyProps
			}
		}
	}
	${DutyProps}
`;

const UPDATE = gql`
	mutation UpdateDuty($id: ID!, $name: String!) {
		UpdateRotaDutyPeroid(id: $id, name: $name) {
			message
			doc {
				...DutyProps
			}
		}
	}
	${DutyProps}
`;
export { LIST, CREATE, UPDATE };
